module.exports = __webpack_public_path__ + "static/00003.be24866c.jpg";